var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var PropTypes = require('prop-types');
var facebook = require('../../utils/facebook');

var FBLoginButton = createReactClass({
    mixins: [PureRenderMixin],

    componentDidMount: function(){
        facebook.init();
    },

    fbLoginCallback: function(response) {
        if (response.status === 'connected') {
            // Logged into your app and Facebook.
            this.props.authFacebook(response.authResponse.accessToken, this.props.source, this.props.loginRedirectUrl, this.props.analyticsLabelSuffix);
        } else if (response.status === 'not_authorized') {
            // The person is logged into Facebook, but not your app.
            // console.log('Please log into this app.');
        } else {
            // The person is not logged into Facebook, so we're not sure if
            // they are logged into this app or not.
            // console.log('Please log into Facebook.');
        }
    },

    loginWithFB: function(){
        if(typeof window.FB !== 'undefined'){
            window.FB.login(function(response){
               this.fbLoginCallback(response);
           }.bind(this), {scope: 'public_profile,email,user_birthday'});
       }else{
           facebook.init();
       }
    },

    handleClick: function() {
        this.loginWithFB();
        this.props.clickTracking && this.props.clickTracking('Submit', 'Facebook');
    },

    render: function(){
        return (
            <button className="fb-login-button button" onClick={this.handleClick}><span className="ion-social-facebook"></span>{this.props.label || 'Login with Facebook'}</button>
        );
    }
});

FBLoginButton.propTypes = {
    authFacebook: PropTypes.func.isRequired
};

module.exports = FBLoginButton;



// WEBPACK FOOTER //
// ./src/common/routes/components/fbLoginButton.jsx